import { Popover, PopoverProps } from '@amzn/awsui-components-react-v3';
import React from 'react';

export interface HelpTextHOCProps extends Partial<PopoverProps> {
	children: React.JSX.Element;
	helpText: string;
}

export default function HelpTextHOC({
	children,
	helpText,
	...PopoverProps
}: HelpTextHOCProps) {
	return (
		<div className="custom-wrapping">
			<Popover
				dismissButton={false}
				content={helpText}
				triggerType="custom"
				{...PopoverProps}
			>
				{children}
			</Popover>
		</div>
	);
}
